import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Global, css } from '@emotion/react';
import { GrainProvider } from '@flodesk/grain';
import Routes from '@/routes';

const globalStyles = css`
  @font-face {
    font-family: 'Flodesk Sans';
    font-weight: 400;
    src:
      url('/fonts/FlodeskSans/FlodeskSans-Regular.woff2') format('woff2'),
      url('/fonts/FlodeskSans/FlodeskSans-Regular.woff') format('woff');
  }
  @font-face {
    font-family: 'Flodesk Sans';
    font-weight: 500;
    src:
      url('/fonts/FlodeskSans/FlodeskSans-Medium.woff2') format('woff2'),
      url('/fonts/FlodeskSans/FlodeskSans-Medium.woff') format('woff');
  }
  @font-face {
    font-family: 'FlotesqueGX';
    font-weight: 400;
    src: url('/fonts/FlotesqueGX/FlotesqueGX_v2.ttf') format('truetype');
  }
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

export default function App() {
  return (
    <GrainProvider>
      <div className="grn-context">
        <BrowserRouter>
          <Global styles={globalStyles} />
          <Routes />
        </BrowserRouter>
      </div>
    </GrainProvider>
  );
}
